import { MapTo } from "@adobe/aem-react-editable-components";
import { QrCodePointsCollection } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const qrCodePointsCollectionEditConfig = {
    emptyLabel: "QrCodePointsCollection",
    isEmpty: (props) => {
        if (!props ||
            !props.content?.title ||
            !props.content.titleLogged ||
            !props.content.titleCollected ||
            !props.content.text ||
            !props.content.textLogged ||
            !props.content.textCollected)
            return true;
        return ((props.backgroundType === "image" && !props.desktopImage?.src) ||
            (props.backgroundType === "video" && !props.videoFileReference));
    },
    getProps: (props) => props,
};
export default MapTo("loyalty/components/qrcodepointscollection")(withAemAuthoring(QrCodePointsCollection, qrCodePointsCollectionEditConfig));
